import { render } from "./MyTeams.vue?vue&type=template&id=13aa6e18"
import script from "./MyTeams.vue?vue&type=script&lang=js"
export * from "./MyTeams.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__